var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { linkStyles } from './LinkButton.css';
export const LinkButton = React.forwardRef(function LinkButton(_a, ref) {
    var { children, className, onClick } = _a, rest = __rest(_a, ["children", "className", "onClick"]);
    const handleClick = (event) => {
        if (typeof onClick === 'function') {
            if (event.nativeEvent.type === 'click') {
                onClick(event);
            }
            if (event.nativeEvent.type === 'keydown') {
                if (event.code === 'Space' || event.code === 'Enter') {
                    event.preventDefault();
                    onClick(event);
                }
            }
        }
    };
    return (_jsx("span", Object.assign({ className: cx(linkStyles, className), onClick: handleClick, onKeyDown: handleClick, role: "button", tabIndex: 0 }, rest, { ref: ref, children: children })));
});
